"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializer = exports.isErr = exports.isOk = void 0;
var index_1 = require("./index");
function isOk(r) {
    // @ts-ignore
    return r.ok !== undefined ? true : false;
}
exports.isOk = isOk;
function isErr(r) {
    // @ts-ignore
    return r.error !== undefined ? true : false;
}
exports.isErr = isErr;
function serializer(serializers) {
    return {
        container: 'obj',
        description: function () { return "result(".concat(serializers.ok.description(), ",").concat(serializers.error.description(), ")"); },
        read: function (o) {
            if (!(o instanceof Object))
                return (0, index_1.validationError)('object', o);
            if (o.error === undefined) {
                return { ok: serializers.ok.read(o.ok) };
            }
            else {
                return { error: serializers.error.read(o.error) };
            }
        },
        write: function (o) {
            if (isOk(o)) {
                return { ok: serializers.ok.write(o.ok) };
            }
            else {
                return { error: serializers.error.write(o.error) };
            }
        }
    };
}
exports.serializer = serializer;
